import { Directive, Input } from '@angular/core';
import { MediaAlias } from '~shared/models/media.model';
import { AbstractVisibilityClassDirective } from '../classes/visibility-directive.class';

@Directive({
  selector: '[appShowFor]',
})
export class ShowForDirective extends AbstractVisibilityClassDirective {
  @Input('appShowFor') targetMediaAlias: MediaAlias;

  protected onMediaChange(isMediaAliasActive: boolean): void {
    if (isMediaAliasActive) {
      this.showTemplate();
    } else {
      this.hideTemplate();
    }
  }
}
